import { render, staticRenderFns } from "./PromoViewRewardAlertDialog.vue?vue&type=template&id=2d064dda&lang=pug"
import script from "./PromoViewRewardAlertDialog.vue?vue&type=script&lang=ts"
export * from "./PromoViewRewardAlertDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VAlert,VDialog})
